import Typography from '@mui/material/Typography'
import clsx from 'clsx'
import React, { ReactNode } from 'react'
import useStyles from './LinkButton.styles'
import { useTheme } from '@mui/material'

interface Props {
  onClick: () => void
  text?: string
  className?: string
  children?: ReactNode
}

export const LinkButton = (props: Props) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className={clsx(classes.linkButton, props.className)} onClick={props.onClick}>
      {!props.children ? (
        <Typography variant="Lato Emphasized 1" color={theme.palette.primary.main} className={classes.linkText}>
          {props.text}
        </Typography>
      ) : (
        props.children
      )}
    </div>
  )
}
